"use client"

import { Component } from "react"
import { Mobile, PC, Tablet, Notebook } from "../../ReactiveMode"

class Infant extends Component {
  constructor(props) {
    super(props)
  }

  render() {
    return (
        <section className="pf-page">
          {/* 깔끔한 헤더 */}
          <div className="infant-clean-header">
            <div className="header-container">
              <div className="header-content">
                <div className="header-icon">
                  <img
                      src={process.env.REACT_APP_CDN_URL + "/images/education/1.png" || "/placeholder.svg"}
                      alt="영아부 로고"
                      className="department-logo"
                  />
                </div>
                <h1>영아부</h1>
                <p className="motto">하나님이 너무 좋아요!</p>
              </div>
            </div>
          </div>

          <PC>
            <section className="infant-clean-content">
              <div className="content-wrapper">
                {/* 소개 섹션 */}
                <div className="section">
                  <div className="section-header">
                    <h2>영아부 소개</h2>
                  </div>
                  <div className="intro-card">
                    <div className="card-content">
                      <div className="icon-wrapper">
                        <img
                            src="https://hebbkx1anhila5yf.public.blob.vercel-storage.com/%E1%84%8B%E1%85%A7%E1%86%BC%E1%84%8B%E1%85%A1%E1%84%87%E1%85%AE-j49taJccGdzFSkAPdgRVUC75HqflOQ.png"
                            alt="영아부 로고"
                            className="section-logo"
                        />
                      </div>
                      <div className="text-content">
                        <p className="main-text highlight">
                          "예배의 소리를 듣고 자라는 영혼들, 하나님 나라의 첫 씨앗이 되다."
                        </p>
                        <p className="main-text">
                          영아부는 생후 0세에서 만2세의 아기들과 보호자가 함께 예배드리는 부서입니다. 본당 내 모자실에서
                          어머니와 아기들이 함께 예배에 참여하며, 말씀과 찬양 속에 하나님의 임재를 경험합니다.
                        </p>
                        <p className="sub-text">
                          갓난아기들은 엄마 품에 안겨 예배를 듣고, 아이들을 위해 늘 간식과 따뜻한 돌봄을 준비해주시는
                          권사님의 섬김으로 편안하고 안전한 환경이 제공됩니다. 영아부는 아기에게는 믿음의 첫 걸음을,
                          부모에게는 신앙 양육의 시작을 함께하는 은혜의 자리입니다.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                {/* 예배 정보 섹션 */}
                <div className="section">
                  <div className="section-header">
                    <h2>예배 안내</h2>
                  </div>
                  <div className="worship-grid">
                    <div className="worship-card">
                      <div className="worship-header">
                        <div className="worship-icon">
                          <img
                              src="https://hebbkx1anhila5yf.public.blob.vercel-storage.com/%E1%84%8B%E1%85%A7%E1%86%BC%E1%84%8B%E1%85%A1%E1%84%87%E1%85%AE-j49taJccGdzFSkAPdgRVUC75HqflOQ.png"
                              alt="영아부 로고"
                              className="card-logo"
                          />
                        </div>
                        <h3>주일 예배</h3>
                      </div>
                      <div className="worship-content">
                        <p>부모와 아기가 함께 예배드리며 하나님의 임재를 경험하는 소중한 시간입니다.</p>
                        <div className="worship-info">
                          <div className="info-item">
                            <i className="far fa-calendar"></i>
                            <span>매주 일요일</span>
                          </div>
                          <div className="info-item">
                            <i className="far fa-clock"></i>
                            <span>오전 11:30</span>
                          </div>
                          <div className="info-item">
                            <i className="fas fa-map-marker-alt"></i>
                            <span>성실교회 본당 내 모자실</span>
                          </div>
                          <div className="info-item">
                            <i className="fas fa-users"></i>
                            <span>만0세 - 만2세</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* 주제성구 섹션 */}
                <div className="section">
                  <div className="section-header">
                    <h2>주제성구</h2>
                  </div>
                  <div className="scripture-card">
                    <div className="scripture-content">
                      <div className="scripture-icon">
                        <i className="fas fa-book-open"></i>
                      </div>
                      <div className="scripture-text">
                        <p className="verse">
                          "내가 너를 모태에 짓기 전에 너를 알았고, 네가 태어나기도 전에 너를 성별하였으며, 너를 민족들의
                          선지자로 세웠다."
                        </p>
                        <p className="reference">예레미야 1:5</p>
                      </div>
                    </div>
                  </div>
                </div>

                {/* 교육목표 섹션 */}
                <div className="section">
                  <div className="section-header">
                    <h2>교육목표</h2>
                  </div>
                  <div className="goals-grid">
                    <div className="goal-card">
                      <div className="goal-icon">
                        <i className="fas fa-praying-hands"></i>
                      </div>
                      <h3>하나님의 임재 경험</h3>
                      <p>예배의 분위기 속에서 하나님의 임재를<br/>자연스럽게 경험하게 합니다.</p>
                    </div>
                    <div className="goal-card">
                      <div className="goal-icon">
                        <i className="fas fa-heart"></i>
                      </div>
                      <h3>신앙 유대 형성</h3>
                      <p>부모와 아기가 함께 예배드리며<br/>신앙 안에서 유대를 형성하도록<br/>돕습니다.</p>
                    </div>
                    <div className="goal-card">
                      <div className="goal-icon">
                        <i className="fas fa-home"></i>
                      </div>
                      <h3>긍정적 첫 기억</h3>
                      <p>따뜻하고 안전한 환경 속에서 교회에 대한 긍정적인 첫 기억을 심어줍니다.</p>
                    </div>
                  </div>
                </div>

                {/* 예배순서 섹션 */}
                <div className="section">
                  <div className="section-header">
                    <h2>예배순서</h2>
                  </div>
                  <div className="worship-order-card">
                    <div className="order-content">
                      <div className="order-icon">
                        <i className="fas fa-list-ol"></i>
                      </div>
                      <div className="order-text">
                        <p>대예배 순서와 동일하게 진행됩니다.</p>
                        <p className="sub-note">모자실에서 편안하게 예배에 참여하실 수 있습니다.</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </PC>

          <Notebook>
            <section className="infant-clean-content">
              <div className="content-wrapper">
                {/* 소개 섹션 */}
                <div className="section">
                  <div className="section-header">
                    <h2>영아부 소개</h2>
                  </div>
                  <div className="intro-card">
                    <div className="card-content">
                      <div className="icon-wrapper">
                        <img
                            src={process.env.REACT_APP_CDN_URL + "/images/education/1.png" || "/placeholder.svg"}
                            alt="영아부 로고"
                            className="section-logo"
                        />
                      </div>
                      <div className="text-content">
                        <p className="main-text highlight">
                          "예배의 소리를 듣고 자라는 영혼들, 하나님 나라의 첫 씨앗이 되다."
                        </p>
                        <p className="main-text">
                          영아부는 생후 0세에서 만2세의 아기들과 보호자가 함께 예배드리는 부서입니다.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                {/* 예배 정보 섹션 */}
                <div className="section">
                  <div className="section-header">
                    <h2>예배 정보</h2>
                  </div>
                  <div className="worship-grid notebook-worship">
                    <div className="worship-card">
                      <div className="worship-header">
                        <div className="worship-icon">
                          <img
                              src={process.env.REACT_APP_CDN_URL + "/images/education/1.png" || "/placeholder.svg"}
                              alt="영아부 로고"
                              className="card-logo"
                          />
                        </div>
                        <h3>주일 예배</h3>
                      </div>
                      <div className="worship-content">
                        <div className="worship-info">
                          <div className="info-item">
                            <i className="far fa-calendar"></i>
                            <span>매주 일요일</span>
                          </div>
                          <div className="info-item">
                            <i className="far fa-clock"></i>
                            <span>오전 11:30</span>
                          </div>
                          <div className="info-item">
                            <i className="fas fa-map-marker-alt"></i>
                            <span>본당 내 모자실</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* 주제성구 섹션 */}
                <div className="section">
                  <div className="section-header">
                    <h2>주제성구</h2>
                  </div>
                  <div className="scripture-card">
                    <div className="scripture-content">
                      <div className="scripture-text">
                        <p className="verse">"내가 너를 모태에 짓기 전에 너를 알았고..."</p>
                        <p className="reference">예레미야 1:5</p>
                      </div>
                    </div>
                  </div>
                </div>

                {/* 교육목표 섹션 */}
                <div className="section">
                  <div className="section-header">
                    <h2>교육목표</h2>
                  </div>
                  <div className="goals-grid notebook-goals">
                    <div className="goal-card">
                      <div className="goal-icon">
                        <i className="fas fa-praying-hands"></i>
                      </div>
                      <h3>하나님의 임재 경험</h3>
                    </div>
                    <div className="goal-card">
                      <div className="goal-icon">
                        <i className="fas fa-heart"></i>
                      </div>
                      <h3>신앙 유대 형성</h3>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </Notebook>

          <Tablet>
            <section className="infant-clean-content tablet-content">
              <div className="content-wrapper">
                {/* 소개 섹션 */}
                <div className="section">
                  <div className="section-header">
                    <h2>영아부 소개</h2>
                  </div>
                  <div className="intro-card tablet-intro">
                    <div className="card-content">
                      <div className="icon-wrapper">
                        <img
                            src={process.env.REACT_APP_CDN_URL + "/images/education/1.png" || "/placeholder.svg"}
                            alt="영아부 로고"
                            className="section-logo"
                        />
                      </div>
                      <div className="text-content">
                        <p className="main-text highlight">
                          "예배의 소리를 듣고 자라는 영혼들, 하나님 나라의 첫 씨앗이 되다."
                        </p>
                        <p className="main-text">
                          영아부는 생후 0세에서 만2세의 아기들과 보호자가 함께 예배드리는 부서입니다.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                {/* 예배 정보 섹션 */}
                <div className="section">
                  <div className="section-header">
                    <h2>예배 정보</h2>
                  </div>
                  <div className="worship-grid tablet-worship">
                    <div className="worship-card">
                      <div className="worship-header">
                        <div className="worship-icon">
                          <img
                              src={process.env.REACT_APP_CDN_URL + "/images/education/1.png" || "/placeholder.svg"}
                              alt="영아부 로고"
                              className="card-logo"
                          />
                        </div>
                        <h3>주일 예배</h3>
                      </div>
                      <div className="worship-content">
                        <div className="worship-info">
                          <div className="info-item">
                            <i className="far fa-calendar"></i>
                            <span>매주 일요일</span>
                          </div>
                          <div className="info-item">
                            <i className="far fa-clock"></i>
                            <span>오전 11:30</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* 교육목표 섹션 */}
                <div className="section">
                  <div className="section-header">
                    <h2>교육목표</h2>
                  </div>
                  <div className="goals-grid tablet-goals">
                    <div className="goal-card">
                      <div className="goal-icon">
                        <i className="fas fa-praying-hands"></i>
                      </div>
                      <h3>하나님의 임재 경험</h3>
                    </div>
                    <div className="goal-card">
                      <div className="goal-icon">
                        <i className="fas fa-heart"></i>
                      </div>
                      <h3>신앙 유대 형성</h3>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </Tablet>

          <Mobile>
            <section className="infant-clean-content mobile-content">
              <div className="content-wrapper">
                {/* 소개 섹션 */}
                <div className="section mobile-section">
                  <div className="section-header">
                    <h2>영아부 소개</h2>
                  </div>
                  <div className="intro-card mobile-intro">
                    <div className="card-content">
                      <div className="icon-wrapper">
                        <img
                            src={process.env.REACT_APP_CDN_URL + "/images/education/1.png" || "/placeholder.svg"}
                            alt="영아부 로고"
                            className="section-logo"
                        />
                      </div>
                      <div className="text-content">
                        <p className="main-text highlight">
                          "예배의 소리를 듣고 자라는 영혼들, 하나님 나라의 첫 씨앗이 되다."
                        </p>
                        <p className="main-text">
                          영아부는 생후 0세에서 만2세의 아기들과 보호자가 함께 예배드리는 부서입니다.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                {/* 예배 정보 섹션 */}
                <div className="section mobile-section">
                  <div className="section-header">
                    <h2>예배 정보</h2>
                  </div>
                  <div className="worship-grid mobile-worship">
                    <div className="worship-card">
                      <div className="worship-header">
                        <div className="worship-icon">
                          <img
                              src={process.env.REACT_APP_CDN_URL + "/images/education/1.png" || "/placeholder.svg"}
                              alt="영아부 로고"
                              className="card-logo"
                          />
                        </div>
                        <h3>주일 예배</h3>
                      </div>
                      <div className="worship-content">
                        <div className="worship-info">
                          <div className="info-item">
                            <i className="far fa-calendar"></i>
                            <span>매주 일요일</span>
                          </div>
                          <div className="info-item">
                            <i className="far fa-clock"></i>
                            <span>오전 11:30</span>
                          </div>
                          <div className="info-item">
                            <i className="fas fa-map-marker-alt"></i>
                            <span>본당 내 모자실</span>
                          </div>
                          <div className="info-item">
                            <i className="fas fa-users"></i>
                            <span>만0세-만2세</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* 주제성구 섹션 */}
                <div className="section mobile-section">
                  <div className="section-header">
                    <h2>주제성구</h2>
                  </div>
                  <div className="scripture-card mobile-scripture">
                    <div className="scripture-content">
                      <div className="scripture-text">
                        <p className="verse">"내가 너를 모태에 짓기 전에 너를 알았고..."</p>
                        <p className="reference">예레미야 1:5</p>
                      </div>
                    </div>
                  </div>
                </div>

                {/* 교육목표 섹션 */}
                <div className="section mobile-section">
                  <div className="section-header">
                    <h2>교육목표</h2>
                  </div>
                  <div className="goals-grid mobile-goals">
                    <div className="goal-card">
                      <div className="goal-icon">
                        <i className="fas fa-praying-hands"></i>
                      </div>
                      <h3>하나님의 임재 경험</h3>
                    </div>
                    <div className="goal-card">
                      <div className="goal-icon">
                        <i className="fas fa-heart"></i>
                      </div>
                      <h3>신앙 유대 형성</h3>
                    </div>
                    <div className="goal-card">
                      <div className="goal-icon">
                        <i className="fas fa-home"></i>
                      </div>
                      <h3>긍정적 첫 기억</h3>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </Mobile>
        </section>
    )
  }
}

export default Infant
